export default __webpack_public_path__ + "assets/Compare6.png";